import React from 'react';
import css from './WishListToolTip.scss';
import { FormattedMessage as Translation } from 'react-intl';
import PropTypes from 'prop-types';

const WishListToolTip = ({
    toggleFirstTimeUserTips,
    showToolTip
}) => {
    return (
        <>
            {showToolTip && <div className={ css.tips } onClick={ toggleFirstTimeUserTips }>
                <span className={ css.toolTipShow }>
                    <Translation id="whishlistNewPlace" />
                </span>
            </div>}
        </>
    );
};

WishListToolTip.propTypes = {
    toggleFirstTimeUserTips: PropTypes.func,
    showToolTip: PropTypes.bool
};

export default WishListToolTip;
